import { get } from '@/lib/axios'

const state = () => ({

})
const getters = {

}
const mutations = {

}
const actions = {
    async getAssetProofsSummary() {
        return get('/asset-proofs/summary', {params: {dev: process.env.VUE_APP_IS_DEV === '1'}})
    },
    async getAssetProofsList(context, params) {
        return get('/asset-proofs/list', {params})
    }
}
  
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
  